import * as React from 'react';

const WifiSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9 14.6c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5zm0 4c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.6 1.5-1.5 1.5zM11.9 10.1c-2.4 0-4.5 1.2-5.8 3l.7.7c1.1-1.7 2.9-2.8 5-2.8 2.2 0 4.1 1.2 5.1 2.9l.7-.7c-1-1.8-3.2-3.1-5.7-3.1z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9 7.1C8.7 7.1 5.8 8.6 4 11l.7.7C6.4 9.6 9 8.1 11.9 8.1c3 0 5.7 1.5 7.3 3.8l.7-.7c-1.8-2.5-4.7-4.1-8-4.1z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9 4.4c-4 0-7.5 1.8-9.9 4.7l.7.7c2.2-2.7 5.5-4.4 9.2-4.4 3.8 0 7.1 1.8 9.3 4.5l.7-.7c-2.3-2.9-5.9-4.8-10-4.8z"
        />
    </svg>
);

WifiSvg.displayName = 'WifiSvg';
export default WifiSvg;
